/**
 * The role a Heilmittel option plays within a Diagnosegruppe, as expressed in
 * the SDHM Heilmittelkatalog. Drives the guide-and-judge picker ranking and the
 * ergänzend-never-alone rule.
 */
export var CatalogHeilmittelRole;
(function (CatalogHeilmittelRole) {
    /** Vorrangiges Heilmittel — the primary options for the Diagnosegruppe. */
    CatalogHeilmittelRole["VORRANGIG"] = "vorrangig";
    /** Ergänzendes Heilmittel — only prescribable alongside a vorrangiges. */
    CatalogHeilmittelRole["ERGAENZEND"] = "ergaenzend";
    /** Standardisierte Heilmittelkombination. */
    CatalogHeilmittelRole["STANDARDISIERTE_KOMBINATION"] = "standardisierte_kombination";
})(CatalogHeilmittelRole || (CatalogHeilmittelRole = {}));
//# sourceMappingURL=catalog-heilmittel-role.enum.js.map